
import { Link } from 'react-router-dom';
import kingbet9Logo from '../../../assets/kingbet9-logo.png';
import paymentMethodsBanner from '../../../assets/payment-methods-banner.png';
import { RegisterLink } from '../../../components/RegisterLink';

const socialLinks = [
  { label: 'Facebook', icon: 'ri-facebook-fill' },
  { label: 'Twitter', icon: 'ri-twitter-x-fill' },
  { label: 'Instagram', icon: 'ri-instagram-fill' },
  { label: 'Telegram', icon: 'ri-telegram-fill' },
];

const quickLinks = [
  { label: 'About Us', to: '/about-us' },
  { label: 'Slot Pokies', to: '/slot-pokies' },
  { label: 'Fishing Games', to: '/fishing' },
  { label: 'Live Table Casino', to: '/live-table-casino' },
  { label: 'Kingbet9 App', to: '/app' },
];

const supportLinks = [
  { label: 'FAQ', to: '/faq' },
  { label: 'Responsible Gambling', to: '/responsible-gambling' },
  { label: 'Terms & Conditions', to: '/terms-and-conditions' },
  { label: 'Privacy Policy', to: '/privacy-policy' },
];

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-[#0d0d0d] to-[#000000] border-t border-yellow-400/10">
      <div className="container mx-auto px-4 max-w-7xl">
        
        {/* Main Footer Content */}
        <div className="py-10 md:py-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
            
            {/* Brand Section */}
            <div className="sm:col-span-2 md:col-span-1 text-center sm:text-left">
              <div className="mb-4 flex justify-center sm:justify-start">
                <img
                  src={kingbet9Logo}
                  alt="Site logo"
                  className="h-10 w-auto object-contain"
                />
              </div>
              <p className="text-gray-400 text-sm mb-4 leading-relaxed max-w-md mx-auto sm:mx-0">
                Australia's most trusted online entertainment platform, offering live casino, online slots pokies, and fishing games services.
              </p>
              <div className="flex gap-3 justify-center sm:justify-start">
                {socialLinks.map((link) => (
                  <RegisterLink
                    key={link.label}
                    source="footer"
                    label={link.label}
                    className="w-10 h-10 bg-[#1a1a1a] border border-yellow-400/30 rounded-full flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-all cursor-pointer"
                  >
                    <i className={link.icon}></i>
                  </RegisterLink>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div className="text-center sm:text-left">
              <p className="text-white font-bold mb-4 text-sm">Quick Links</p>
              <ul className="space-y-2">
                {quickLinks.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="text-gray-400 hover:text-yellow-400 transition-colors text-sm cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Customer Support */}
            <div className="text-center sm:text-left">
              <p className="text-white font-bold mb-4 text-sm">Customer Support</p>
              <ul className="space-y-2">
                {supportLinks.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="text-gray-400 hover:text-yellow-400 transition-colors text-sm cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Security & Payments */}
            <div className="sm:col-span-2 md:col-span-1 text-center sm:text-left">
              <p className="text-white font-bold mb-4 text-sm">Security &amp; Certifications</p>
              <div className="grid grid-cols-2 gap-2 mb-4 max-w-[220px] mx-auto sm:mx-0">
                <img src="https://www.md88malaysia.com/images/gaming-curacao.11924b2c.png" alt="Curacao License" className="h-8 mx-auto sm:mx-0 opacity-80 hover:opacity-100 transition-opacity" />
                <img src="https://www.md88malaysia.com/images/cert-1.1cc26ee8.png" alt="BMM Testlabs" className="h-8 mx-auto sm:mx-0 opacity-80 hover:opacity-100 transition-opacity" />
                <img src="https://www.md88malaysia.com/images/cert-2.d03ed428.png" alt="iTech Labs" className="h-8 mx-auto sm:mx-0 opacity-80 hover:opacity-100 transition-opacity" />
                <img src="https://www.md88malaysia.com/images/cert-3.1ba00de8.png" alt="Secure Payouts" className="h-8 mx-auto sm:mx-0 opacity-80 hover:opacity-100 transition-opacity" />
              </div>
              <p className="text-white font-semibold mb-2 text-xs">Payment Methods</p>
              <div className="flex justify-center sm:justify-start">
                <img
                  src={paymentMethodsBanner}
                  alt="Accepted payment methods"
                  className="w-full max-w-[360px] h-auto rounded-md opacity-90 hover:opacity-100 transition-opacity"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-yellow-400/10 py-5 md:py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-gray-500 text-xs">
            <div className="flex items-center gap-3 md:gap-6 flex-wrap justify-center md:justify-start text-center md:text-left">
              <p>© 2026 Kingbet9 Online Casino. All Rights Reserved.</p>
              <div className="flex items-center gap-1">
                <span>Licensed &amp; Regulated in Australia</span>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <Link to="/responsible-gambling" className="text-yellow-400 text-xs hover:text-yellow-300">
                18+ | Kingbet9 Responsible Gambling
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
